var map = {
	"./administration/administration.module": [
		"./src/app/administration/administration.module.ts",
		"default~administration-administration-module~dashboard-dashboard-module~local-local-module~national-~0ba5c14c",
		"common",
		"administration-administration-module"
	],
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"default~authentication-authentication-module~local-local-module",
		"common",
		"authentication-authentication-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~administration-administration-module~dashboard-dashboard-module~local-local-module~national-~0ba5c14c",
		"default~dashboard-dashboard-module~local-local-module~national-national-module~regional-regional-mod~4e17268f",
		"common",
		"dashboard-dashboard-module"
	],
	"./docs/docs.module": [
		"./src/app/docs/docs.module.ts",
		"docs-docs-module"
	],
	"./error/error.module": [
		"./src/app/error/error.module.ts",
		"error-error-module"
	],
	"./local/local.module": [
		"./src/app/local/local.module.ts",
		"default~administration-administration-module~dashboard-dashboard-module~local-local-module~national-~0ba5c14c",
		"default~dashboard-dashboard-module~local-local-module~national-national-module~regional-regional-mod~4e17268f",
		"default~authentication-authentication-module~local-local-module",
		"common",
		"local-local-module"
	],
	"./national/national.module": [
		"./src/app/national/national.module.ts",
		"default~administration-administration-module~dashboard-dashboard-module~local-local-module~national-~0ba5c14c",
		"default~dashboard-dashboard-module~local-local-module~national-national-module~regional-regional-mod~4e17268f",
		"default~national-national-module~regional-regional-module",
		"common",
		"national-national-module"
	],
	"./regional/regional.module": [
		"./src/app/regional/regional.module.ts",
		"default~administration-administration-module~dashboard-dashboard-module~local-local-module~national-~0ba5c14c",
		"default~dashboard-dashboard-module~local-local-module~national-national-module~regional-regional-mod~4e17268f",
		"default~national-national-module~regional-regional-module",
		"common",
		"regional-regional-module"
	],
	"./shop/shop.module": [
		"./src/app/shop/shop.module.ts",
		"default~administration-administration-module~dashboard-dashboard-module~local-local-module~national-~0ba5c14c",
		"default~dashboard-dashboard-module~local-local-module~national-national-module~regional-regional-mod~4e17268f",
		"common",
		"shop-shop-module"
	],
	"./user/user.module": [
		"./src/app/user/user.module.ts",
		"default~administration-administration-module~dashboard-dashboard-module~local-local-module~national-~0ba5c14c",
		"common",
		"user-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;